<script>

import { Account, ShoppingCart, Location, Merchant, util } from './../../functions.js'

import AccountAPI from './../../api/account.js'
import LocationAPI from './../../api/location.js'

import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'
import AlertDialogue from './../shared/AlertDialogue.vue'
import ConfirmDialogue from './../shared/ConfirmDialogue.vue'

export default {
  name: 'Register',
  components: {
    Footer,
    HeaderFive,
    AlertDialogue,
    ConfirmDialogue
  },
  watch: {
     $route (new_value, old_value) {
        if(this.$route.query.status == 'success' && this.$route.query.id != '')
        {
          this.registered = true;
        }
        else
        {
          this.registered = false;
        }
    },
    show_error (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value == true) {
        setTimeout(() => {
          this.show_error = false;
          this.error_message = '';
        }, 5000)
      }
    }
  },
  data () {
    return {
      show_error: false,
      error_message: '',
      registered_business_name: '',
      address: '',
      sec_registration_num: '',
      sec_registration_file: [],
      sec_file_base64: '',
      dti_registration_num: '',
      dti_registration_file: [],
      tin_num:'',
      tin_file: [],
      additional_documents: [], // Array for document names
      additional_documents_file: [], // Array for file objects
      additional_document_count: 1, // for new set of additional document to appear
      mobile_number: '',
      position: '',
      tel_number: '',
      province_list: [],
      barangay_list: [],
      city_list: [],
      barangay: {
        brgy_code: '',
        brgy_name: '',
      },
      province: {
        province_code: '',
        province_name: '',
      },
      city: {
        city_code: '',
        city_name: '',
      },
      first_name: '',
      last_name: '',
      trade_name: '',
      classificationData: [], //New Added Customer Classification`
      channel_classification: '', //New Added Customer Classification`
      links: [], // New added social media links
      linkInput: '', // New added social media links
      email_address: '',
      referral_code: '',
      marketing_consent: false,
      privacy_policy_consent: false,
      submitting: false,
      registered: false
    }
  },
  computed: {
    linksText: {
      // Display the links in the textarea, separated by newlines
      get() {
        return this.links.join('\n');
      },
    }
  },
  mounted() {
    try {

      var check_consent = this.$cookies.get("gfs_privacy_reg");
      if(!check_consent)
      {
        this.showPrivacyPolicy();
      }

      var province_request = LocationAPI.getProvinces()
      province_request.then((response) => {
        if (response.length) {
          this.province_list = response
        }
      });


      if(this.$route.query.status == 'success' && this.$route.query.id != '')
      {
        this.registered = true;
      }
    } catch (error) {

    }
    this.linkInput = this.linksText;
  },
  async created() {
    await this.getCustomerClassification();
  },
  onMounted() {
    this.linkInput = this.linksText;
  },

  methods: {
    showPrivacyPolicy()
    {
      var privacypolicy = this.$refs.alertDialogue.show({
            title: "Privacy Statement",
            message: `By supplying the information via this form and clicking the &quot;I Accept&quot; button, I affirm that I have read, understood and hereby<br>
                      accept the terms of San Miguel Foods’ Website <a href='/privacy-statement'>Privacy Statement</a> and <a href='https://irp.cdn-website.com/9ac720e8/files/uploaded/smfb_data_privacy_policy_jan262023.pdf' target='_blank'>Data Privacy Policy</a> and that I hereby consent<br>
                      to the collection, storage, and processing by San Miguel Foods and any third arty it authorizes, including its subsidiaries,<br>
                      affiliates and their respective officers, employees, agents, representatives and personnel of such information disclosed.`,
            okButton: 'I Accept',
        });
        if(privacypolicy)
        {
           this.$cookies.set("gfs_privacy_reg", 1, "30d");
        }

    }, 
    resetForm()
    {
      this.show_error = false;
      this.error_message= '';
      this.registered_business_name= '';
      this.address= '';
      this.sec_registration_num= '';
      this.sec_registration_file= [];
      this.sec_file_base64 = '';
      this.dti_registration_num= '';
      this.dti_registration_file= [];
      this.tin_num='';
      this.tin_file= [];
      this.additional_documents= [];
      this.additional_documents_file= [];
      this.additional_document_count = 1
      this.mobile_number= '';
      this.position= '';
      this.tel_number= '';
      this.province_list= [];
      this.barangay_list= [];
      this.city_list= [];
      this.barangay= {
        brgy_code: '',
        brgy_name: ''
      };
      this.province= {
        province_code: '',
        province_name: ''
      };
      this.city= {
        city_code: '',
        city_name: ''
      };
      this.merchant = {
        merchant_id: 0,
        merchant_weight_limit: 0
      };
      this.first_name= '';
      this.last_name= '';
      this.trade_name= ''; 
      this.channel_classification= '', //New added customer classification
      this.links= [], // New added social media links
      this.linkInput= '', // New added social media links
      this.email_address= '';
      this.referral_code= '';
      this.marketing_consent= false;
      this.privacy_policy_consent= false;
      this.submitting= false;
    },
    uploadAttachments(file_var, uuid, upload_type)
    {
      if(file_var == null) {
        return false;
      }
      else
      {
        var submit_files = AccountAPI.submitAttachments(
          file_var[0].fileObject.type,
          file_var[0].fileObject.name,
          file_var[0].dataURL, uuid, upload_type);
        submit_files.then((response)=>{

        });
      }
    },
    uploadSecRegFile(event) {
  // fixme: event does not get triggered if the same photo is reselected
  if (!event.target.files.length) return;

  const files = event.target.files;
  const maxFileSize = 25 * 1024 * 1024; // 25 MB in bytes

  for (let i = 0; i < files.length; ++i) {
    const file = files[i];
    if (file.type !== 'application/pdf') {
      this.show_error = true; 
      this.error_message = `The file uploaded for SEC registration is not a PDF. Please upload a PDF file.`; 
      this.$refs['title'].scrollIntoView({ behavior: 'smooth' })

      this.resetFileInput(event.target); // Reset the input field
      return; // Stop processing if the file type is invalid
    }
    // Validate file size before processing
    if (file.size > maxFileSize) {
      this.show_error = true;
      this.error_message = `The file uploaded for SEC registration exceeds the maximum allowed size of 1 KB.`;
      this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      this.resetFileInput(event.target); // Reset input on error
      return; // Skip this file and proceed to the next one if any
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      // Insert the file data into the sec_registration_file array
      this.sec_registration_file.push({
        fileObject: file,
        dataURL: e.target.result,
      });
      this.sec_file_base64 = e.target.result;
      // Reset error when a valid file is added
      this.show_error = false;
      this.error_message = '';
    };

    reader.readAsDataURL(file);
  }
},

uploadDtiRegFile(event) {
  // fixme: event does not get triggered if the same photo is reselected
  if (!event.target.files.length) return;

  const files = event.target.files;
  const maxFileSize = 25 * 1024 * 1024; // 25 MB in bytes

  for (let i = 0; i < files.length; ++i) {
    const file = files[i];
    if (file.type !== 'application/pdf') {
      this.show_error = true; 
      this.error_message = `The file uploaded for DTI registration is not a PDF. Please upload a PDF file.`;
      this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
 
      this.resetFileInput(event.target); // Reset the input field
      return; // Stop processing if the file type is invalid
    }
    // Validate file size before processing
    if (file.size > maxFileSize) {
      this.show_error = true;
      this.error_message = `The file uploaded for DTI registration exceeds the maximum allowed size of 25 MB.`;
      this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      this.resetFileInput(event.target); // Reset input on error
      return;
    }else{

      const reader = new FileReader();
      reader.onload = (e) => {
        // Insert the file data into the dti_registration_file array
        this.dti_registration_file.push({
          fileObject: file,
          dataURL: e.target.result,
        });
        // Reset error when a valid file is added
        this.show_error = false;
        this.error_message = '';
      };
  
      reader.readAsDataURL(file);
    }
    }

},

uploadTinFile(event) {
  if (!event.target.files.length) return;

  const files = event.target.files;
  const maxFileSize = 25 * 1024 * 1024; // 25 MB in bytes

  for (let i = 0; i < files.length; ++i) {
    const file = files[i];
    if (file.type !== 'application/pdf') {
      this.show_error = true; 
      this.error_message = `The file uploaded for TIN is not a PDF. Please upload a PDF file.`; 
      this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      this.resetFileInput(event.target); // Reset the input field
      return; // Stop processing if the file type is invalid
    }
    // Validate file size before processing
    if (file.size > maxFileSize) {
      this.show_error = true;
      this.error_message = `The file uploaded for TIN exceeds the maximum allowed size of 25 MB.`;
      this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      this.resetFileInput(event.target); // Reset input on error
      return; // Stop processing further files
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      // Insert the file data into the tin_file array
      this.tin_file.push({
        fileObject: file,
        dataURL: e.target.result,
      });
    };

    reader.readAsDataURL(file);
  }

  // Reset the input to allow reselecting the same file
  
},

resetFileInput(input) {
  input.value = ''; // Reset the input to allow reselecting the same file
},



  //New Added Additional Documents Start
  uploadAdditionalFile(index, event) {
  
  if (!event.target.files.length) {
    console.log(`No files selected for document ${index + 1}.`);
    return; 
  }

  const files = Array.from(event.target.files); 
  const maxFileSize = 134 * 1024; 

  
  if (!this.additional_documents_file[index]) {
    this.$set(this.additional_documents_file, index, []); 
  }

  for (const file of files) {
    if (file.type !== 'application/pdf') {
      this.show_error = true; 
      this.error_message = `The file uploaded for additional document ${index + 1} is not a PDF. Please upload a PDF file.`; 
      this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      this.resetFileInput(event.target); // Reset the input field
      return; // Stop processing if the file type is invalid
    }
    if (file.size > maxFileSize) {
      this.show_error = true; 
      this.error_message = `The file uploaded for additional document ${index + 1} exceeds the maximum allowed size of 25 MB.`;
      this.$refs['title'].scrollIntoView({ behavior: 'smooth' }) 
      this.resetFileInput(event.target); 
      return; 
    }

    const reader = new FileReader(); 
    reader.onload = (e) => {
      this.additional_documents_file[index].push({
        fileObject: file,
        dataURL: e.target.result, 
      });
    };

    reader.readAsDataURL(file);
  }

  console.log(`Uploaded files for document ${index + 1}:`, this.additional_documents_file[index]);
},


    addFile() {
      if (this.additional_document_count < 3) {
        this.additional_document_count += 1;
        this.additional_documents.push(''); // Add a new entry for the document name
        this.additional_documents_file.push([]); // Initialize an array for the new document's files
      }
    },
    removeFile(index) {
    if (this.additional_document_count > 1) {
      this.additional_documents.splice(index - 1, 1); // Remove the document name
      this.additional_documents_file.splice(index - 1, 1); // Remove the associated files
      this.additional_document_count -= 1;
    }
  },

  //New Added Additional Documents End

    //New Added Getting List of Customer Classification  Start

    async getCustomerClassification() {
      try {
        const response = await AccountAPI.customerClassification();  // No need for .then()
        
        if (response) {
          this.classificationData = response.data
        } else {
          console.log('Error in Getting the Customer Classification');
        }
      } catch (error) {
        console.log('Something went wrong in the request:', error);
   
      }
    },
      //New Added Getting List of Customer Classification  End


    async loadCities (event) {
      this.city_list = [];
      this.barangay_list = [];
       this.barangay = {
        brgy_code: '',
        brgy_name: '',
      };
      this.city = {
        city_code: '',
        city_name: '',
      };



      var province_code = event.target.value;
      var province_name = '';

      this.province_list.forEach((p, p_index)=>{
        if(p.psgcCode == province_code)
        {
          province_name = p.provDesc;
        }
      });

      this.province = {
        'province_code': province_code,
        'province_name': province_name,
      };


      setTimeout(()=>{
        var city_request = LocationAPI.getCities(province_code)
        city_request.then((response) => {
          if (response.length) {
            this.city_list = response;
          }
        })
      },200);
    },
    async loadBarangay (event) {
      this.barangay_list = [];
       this.barangay = {
        brgy_code: '',
        brgy_name: '',
      };
     
      var city_code = event.target.value;
      var city_name = '';

      this.city_list.forEach((c, c_index)=>{
        if(c.citymunCode == city_code)
        {
          city_name = c.citymunDesc;
        }
      });

      this.city = {
        'city_code': city_code,
        'city_name': city_name,
      };

      setTimeout(()=>{
        var barangay_request = LocationAPI.getBarangay(city_code)
        barangay_request.then((response) => {
          if (response.length) {
            this.barangay_list = response
          }
        })

      },200);
    },
    async loadLocationData(event)
    {
       var brgy_code = event.target.value;
       var brgy_name = '';
       var merchant_id = 0;
       var merchant_weight_limit = 0;
      
      this.barangay_list.forEach((b, b_index)=>{
        if(b.brgyCode == brgy_code)
        {
          brgy_name = b.brgyDesc;
          merchant_id = b.merchant_id;
          merchant_weight_limit = b.weight_limit;
        }
      });

      this.barangay = {
        'brgy_code': brgy_code,
        'brgy_name': brgy_name,
      };
` `
      this.merchant = {
        merchant_id: merchant_id,
        merchant_weight_limit : merchant_weight_limit
      };

    },
    validateRegistration() {
  var error = {
    message: '',
    has_error: 0
  };

  // Validate business information
  if (this.registered_business_name.trim() == '') {
    error.message = 'Please enter your Registered Business Name';
    error.has_error = 1;
    return error;
  } else if (this.province.province_code.trim() == '') {
    error.message = 'Please select your Province';
    error.has_error = 1;
    return error;
  } else if (this.city.city_code.trim() == '') {
    error.message = 'Please select your City';
    error.has_error = 1;
    return error;
  } else if (this.barangay.brgy_code.trim() == '') {
    error.message = 'Please select your Barangay';
    error.has_error = 1;
    return error;
  } else if (this.address.trim() == '') {
    error.message = 'Please enter your Address';
    error.has_error = 1;
    return error;
  } else if (this.channel_classification.trim() == '') {
    error.message = 'Please select customer classification';
    error.has_error = 1;
    return error;
  }

  // Validate additional documents
 // Validate additional documents
if (this.additional_document_count > 1) {
  const maxFileSize = 1 * 24//5 * 1024 * 1024; // Maximum file size in bytes (e.g., 5 MB)

  for (let i = 0; i < this.additional_document_count; i++) {
    const docName = this.additional_documents[i] ? this.additional_documents[i].trim() : '';
    const docFiles = this.additional_documents_file[i] ? this.additional_documents_file[i] : [];

    // Check if the document name is empty and there are no files uploaded
    if (docName === '' && docFiles.length === 0) {
      error.message = `Please provide a name and a file for additional document ${i + 1}.`;
      error.has_error = 1;
    } else if (docName === '') {
      error.message = `Please provide a name for additional document ${i + 1}.`;
      error.has_error = 1;
    } else if (docFiles.length === 0) {
      error.message = `Please provide a file for additional document ${i + 1}.`;
      error.has_error = 1;
    } else {
      // Validate each file size
      for (let j = 0; j < docFiles.length; j++) {
        const file = docFiles[j];
        if (file.size > maxFileSize) {
          error.message = `The file uploaded for additional document ${i + 1} exceeds the maximum size of 5 MB.`;
          error.has_error = 1;
          break; // Exit the loop if an error is found for this document
        }
      }
    }

    // If an error is found, break the main loop as well to avoid redundant checks
    if (error.has_error) break;
  }
}

if (error.has_error) {
  return error; // Return early if there are errors
}

  // Validate personal information
  else if (this.first_name.trim() == '') {
    error.message = 'Please enter your First Name';
    error.has_error = 1;
    return error;
  } else if (this.last_name.trim() == '') {
    error.message = 'Please enter your Last Name';
    error.has_error = 1;
    return error;
  } else if (this.position.trim() == '') {
    error.message = 'Please enter Position';
    error.has_error = 1;
    return error;
  } else if (this.tel_number.trim() == '') {
    error.message = 'Please enter Telephone Number';
    error.has_error = 1;
    return error;
  } else if (!(/\d{7}$/).test(this.tel_number)) {
    error.message = 'Please enter a valid Telephone Number';
    error.has_error = 1;
    return error;
  } else if (this.mobile_number.trim() == '') {
    error.message = 'Please enter Mobile Number';
    error.has_error = 1;
    return error;
  } else if (!(/^(09|639)\d{9}$/).test(this.mobile_number)) {
    error.message = 'Please enter a valid Mobile Number';
    error.has_error = 1;
    return error;
  } else if (this.email_address == '') {
    error.message = 'Please enter your Email Address';
    error.has_error = 1;
    return error;
  } else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email_address))) {
    error.message = 'Please enter a valid Email Address';
    error.has_error = 1;
    return error;
  } else if (this.privacy_policy_consent == false) {
    error.message = 'Please confirm your consent to privacy policy';
    error.has_error = 1;
    return error;
  }

  return error; // Return no error if all validations pass
},

    refreshRegistration()
    {
      this.registered = false;
      this.submitting = false;
      this.show_error = false;
      this.error_message = '';
    },
    numericOnly(e)
    {
      var charCode = (e.which) ? e.which : e.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
       
    },
    async register () {
      this.show_error = false
      this.error_message = ''

      var validation = this.validateRegistration()
      if (validation.has_error) {
        this.show_error = true
        this.error_message = validation.message
        this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      } 
      
    else {
        try {
           // Split the input by common separators: comma, period, space, newline, etc.
          const separators = /[,\s\n]+/;
          this.links = this.linkInput.split(separators).filter(link => link.trim() !== '');
          this.linkInput = this.links.join('\n');
           const doc1 = this.additional_documents[0] || '';
          const doc2 = this.additional_documents[1] || '';
          const doc3 = this.additional_documents[2] || '';
          this.submitting = true
          var uuid = '';
          var regid_request = AccountAPI.getRegisterId();
          regid_request.then((response)=>{
            if(response.status == 'success')
            {
              uuid = response.uuid;

              var register_request = AccountAPI.register(
              this.first_name,
              this.last_name,
              this.position,
              this.tel_number,
              this.mobile_number,
              this.email_address,
              this.referral_code,
              this.marketing_consent,
              this.privacy_policy_consent,
              this.registered_business_name,
              this.trade_name,
              this.address,
              this.province,
              this.city,
              this.barangay,
              this.sec_registration_num,
              this.dti_registration_num,
              this.tin_num,
              this.channel_classification,
              this.links,
              doc1,
              doc2,
              doc3,
              uuid
            )

            register_request.then((register) => {
              if (register.status == 'Success.') {
                this.registered = true;
                this.submitting = false;

                if(this.sec_registration_file.length)
                {
                  this.uploadAttachments(this.sec_registration_file,uuid, 'SEC_REG');
                }

                if(this.dti_registration_file.length)
                {
                  this.uploadAttachments(this.dti_registration_file,uuid, 'DTI_REG');
                }

                if(this.tin_file.length)
                {
                  this.uploadAttachments(this.tin_file,uuid, 'TIN_NUM');
                }

                this.additional_documents.forEach((doc, index) => {
                  if (this.additional_documents_file[index] && this.additional_documents_file[index].length) {
                    this.uploadAttachments(this.additional_documents_file[index], uuid, `docs${index + 1}`);
                  }
                });


                // If not logged in, save registered account info and customer id
                if(Account.getLoginId() == '' || Account.getToken() == '')
                {
                  var info = {
                    registered_business_name: this.registered_business_name,
                    trade_name: this.trade_name,
                    province: this.province,
                    city: this.city,
                    barangay: this.barangay,
                    address: this.address,
                    sec_no: this.sec_registration_num,
                    dti_no: this.dti_registration_num,
                    tin_no: this.tin_num,
                    sec_file: this.sec_registration_file,
                    dti_file: this.dti_registration_file,
                    tin_file: this.tin_file,
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email_address: this.email_address,
                    telephone_number: this.tel_number,
                    mobile_number: this.mobile_number,
                    position: this.position,
                    channel_classification: this.channel_classification,
                    links: this.links, //New added social links
                    uuid: uuid,
                  };

                  // ShoppingCart.cart = ShoppingCart.EMPTY_CART;
                  // ShoppingCart.setCart(ShoppingCart.cart);

                  //  Location.setLocation({
                  //     province: this.province,
                  //     city: this.city,
                  //     barangay: this.barangay
                  //   });

                   Account.setInfo(info);
                   Account.setCustomerID(register.data.customer_id);
                 
                   var cart = ShoppingCart.cart[ShoppingCart.active_shopping_cart].products;
                   console.log(cart);
                   if(cart.length)
                   {
                        if(this.barangay.brgy_code != Location.location.barangay.brgy_code)
                        {

                            var change_merchant = ShoppingCart.changeMerchant(this.barangay.brgy_code);
                            change_merchant.then((updated_products)=>{
                              console.log(updated_products);

                              if(updated_products.status == 'success' && updated_products.products.length && !updated_products.updated)
                              {
                                  Location.setLocation({
                                    province: this.province,
                                    city: this.city,
                                    barangay: this.barangay
                                  });
                                  Merchant.setMerchant(this.merchant);
                                  this.resetForm();
                                this.$router.push({ name: 'checkout' });
                              }
                              else {

                                    let displayed_product_data = {
                                        subtotal: 0,
                                        products: []
                                    };

                                     cart.forEach((product,product_index)=>{
                                        var p = {
                                          product: null,
                                          quantity: 0
                                        };

                                        p.product = product.product;
                                        updated_products.products.forEach((new_product, new_product_index)=>{
                                            var sku_raw = product.product.sku.substring(0, product.product.sku.indexOf("-"));
                                            if(new_product.product.sku.includes(sku_raw))
                                            {
                                              p.quantity = new_product.new_qty;
                                            }
                                        });

                                        displayed_product_data.subtotal += (p.product.product_price) * p.quantity;
                                        displayed_product_data.products.push(p);
                                    });


                                   let product_list_message = "<ul class='updated-product-list'>";
                                    displayed_product_data.products.forEach((dp, dp_i)=>{
                                      // if(dp.quantity>0)
                                      // {
                                        product_list_message = product_list_message + "<li>" + dp.quantity + " x " + dp.product.product_name + "</li>";
                                      // }
                                    });
                                    product_list_message  = product_list_message + "</ul>";


                                    let subtotal_message = 'Subtotal: ' + displayed_product_data.subtotal;
                                    let custom_message = "There was a change in the available stock. Kindly refer to your updated cart. Please click “Proceed” to accept the changes and continue with your order."+product_list_message+"";
                                    var update_product_merchant  = false;

                                    if(updated_products.change_quantity == true)
                                    {
                                      let show_popup = this.$refs.confirmDialogue.show({
                                          title: "You have items in your Cart",
                                          message: custom_message,
                                          okButton: 'Proceed',
                                          cancelButton: 'Cancel'
                                      });

                                      show_popup.then((response)=>{
                                          if(response)
                                          {
                                               var new_cart_products = [];

                                             cart.forEach( (p,p_index)=>{
                                              updated_products.products.forEach( (np,np_index)=>{
                                                var sku_raw = p.product.sku.substring(0, p.product.sku.indexOf("-"));
                                                if(np.product.sku.includes(sku_raw))
                                                {
                                                  new_cart_products.push({
                                                    product: np.product,
                                                    quantity: np.new_qty,
                                                  });
                                                }
                                              });
                                            });

                                            Location.setLocation({
                                                "province": this.province,
                                                "city": this.city,
                                                "barangay": this.barangay
                                            });
                                            Merchant.setMerchant(this.merchant);

                                            cart = new_cart_products;
                                            ShoppingCart.cart[ShoppingCart.active_shopping_cart].products = cart;
                                            ShoppingCart.setCart(ShoppingCart.cart);

                                            if(cart.length)
                                            {
                                              this.$router.push({ name: 'checkout' });
                                            }
                                            else
                                            {
                                                this.$refs.alertDialogue.show({
                                                    title: "Your Cart is now Empty",
                                                    message: "Some of the products you selected are not available in your selected area.",
                                                    okButton: 'Back to Home',
                                               
                                                });
                                                 this.$router.push({ name: 'checkout' });
                                            }
                                          }

                                      });
                                    }
                                    else
                                    {
                                      console.log("1");
                                         var new_cart_products = [];

                                         cart.forEach( (p,p_index)=>{
                                          updated_products.products.forEach( (np,np_index)=>{
                                            var sku_raw = p.product.sku.substring(0, p.product.sku.indexOf("-"));
                                            if(np.product.sku.includes(sku_raw))
                                            {
                                              new_cart_products.push({
                                                product: np.product,
                                                quantity: np.new_qty,
                                              });
                                            }
                                          });
                                        });

                                        Location.setLocation({
                                            "province": this.province,
                                            "city": this.city,
                                            "barangay": this.barangay
                                        });
                                        Merchant.setMerchant(this.merchant);

                                        cart = new_cart_products;
                                        ShoppingCart.cart[ShoppingCart.active_shopping_cart].products = cart;
                                        ShoppingCart.setCart(ShoppingCart.cart);

                                        if(cart.length)
                                        {
                                          this.$router.push({ name: 'checkout' });
                                        }
                                        else
                                        {
                                            this.$refs.alertDialogue.show({
                                                title: "Your Cart is now Empty",
                                                message: "Some of the products you selected are not available in your selected area.",
                                                okButton: 'Back to Home',
                                           
                                            });
                                             this.$router.push({ name: 'checkout' });
                                        }
                                    }

                                    
                              }
                              
                            });
                        }
                        else
                        {

                          Merchant.setMerchant(this.merchant);
                            Location.setLocation({
                            province: this.province,
                            city: this.city,
                            barangay: this.barangay
                          });
                            this.resetForm();

                        }

                   }
                   else
                   {

                      Merchant.setMerchant(this.merchant);
                       Location.setLocation({
                      province: this.province,
                      city: this.city,
                      barangay: this.barangay
                    });
                       this.resetForm();

                   }

                }
                else
                {
                  this.resetForm();
                }




                  var redirect_url = (this.$route.query.redirect ? this.$route.query.redirect : '');
                  if(redirect_url != '')
                  {

                     this.$refs['title'].scrollIntoView({ behavior: 'smooth' })

                     setTimeout(()=>{
                        this.$router.push({ name: redirect_url });
                        
                     },3000);
                  }
                  else
                  {
                     this.$router.push({ name: 'register', query: { status: 'success', id: register.data.customer_id } });
                     this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
                  }

               
              }
              else
              {
                  for (const field in register.errors) {
                      register.errors[field].forEach((error, error_index) =>{
                          this.error_message = error;
                      });
                  };
                  this.registered = false;
                 this.submitting = false;
                 this.show_error = true;
                   this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
              }
            })

            }
            else
            {
              this.submitting = false;
              this.show_error = true;
              this.error_message = 'Unable to register account. Please try again later';
              this.$refs['title'].scrollIntoView({ behavior: 'smooth' })

            }
          });


          
        } catch (error) {
          this.submitting = false
          this.show_error = true
          this.error_message = error
          this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
        }
      }
    },
  }
}
</script>

<template>
  <div class="page register-page">
    <HeaderFive />

      <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                          
                            <h1 class="section-title white-color">Account</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Register</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="anchor" ref="title" ></div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- LOGIN AREA START (Register) -->
    <div class="ltn__login-area pb-110" >
        <div class="container" v-if="!registered">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2 text-center">
                        <h1  class="section-title">Register <br>Your Account</h1>
                        
                    </div>
                     <div v-if="show_error" class="alert alert-danger" role="alert">{{ error_message }}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="account-login-inner">
                        <div class="ltn__form-box contact-form-box">
                           <div class="row">
                             <div class="col-lg-6 form-fields">
                               <div>
                                 <label for="registered_business_name">Registered Business Name <span style="color: red;">*</span></label>
                                 <input type="text" name="registered_business_name" id="registered_business_name" v-model="registered_business_name" placeholder="Registered Business Name" required>
                               </div>

                                 <h6>Delivery Address</h6>
                               <div class="mb-25 bordered-content">
                                   <label for="province">Province <span style="color: red;">*</span></label>
                                 <select @change="loadCities" class="c-select" id="province" required v-model="province.province_code">
                                  <option selected disabled value="">Select Province</option>
                                  <option v-for="province in province_list" :value="province.psgcCode">{{ province.provDesc }}</option>
                                </select>
                                <label for="city">City <span style="color: red;">*</span></label>
                                <select @change="loadBarangay" class="c-select" id="city" :disabled="!city_list.length" required v-model="city.city_code">
                                  <option selected disabled value="">Select City</option>
                                  <option v-for="city in city_list" :value="city.citymunCode">{{ city.citymunDesc }}</option>
                                </select>
                                <label for="barangay">Barangay <span style="color: red;">*</span></label>
                                <select @change="loadLocationData" class="c-select" id="barangay" :disabled="!barangay_list.length" required v-model="barangay.brgy_code">
                                  <option selected disabled value="">Select Barangay</option>
                                  <option v-for="barangay in barangay_list" :value="barangay.brgyCode">{{ barangay.brgyDesc }}</option>
                                </select>
                                 <label for="address">Street Address (No. & Street Name) <span style="color: red;">*</span></label>
                                   <input type="text" name="address" v-model="address" id="address" placeholder="Address" required>
                               </div>
                               <div>
                                 <label for="trade_name">Trade Name (If different)</label>
                                  <input type="text" name="trade_name" v-model="trade_name" id="trade_name" placeholder="Trade Name" required>
                               </div>

                               <!-- New Added Customer Classification Start-->
                               <div>
                                <label for="channel_classification">Channel Classification</label>
                                <select v-model="channel_classification" id="channel_classification" class="c-select" required>
                                  <option selected disabled value="">Select Channel Classification</option>
                                  <option v-for="classification in classificationData" :key="classification.code" :value="classification.code">
                                    {{ classification.name }}
                                  </option>
                                </select>
                              </div>

                               <!-- New Added Customer Classification End-->

                             </div>
                             <div class="col-lg-6 form-fields">
                               <div class="with-upload row">
                                 <div class="col-lg-7">
                                   <label for="sec_registration_num">SEC Registration Number</label>
                                   <input type="text" class="mb-10" id="sec_registration_num" name="sec_registration_num" v-model="sec_registration_num" placeholder="SEC Registration Number">
                                 </div>
                                 <div class="col-lg-5">
                                   <label for="sec_registration_file">Upload File</label>
                                   <input id="sec_registration_file" type="file" class="mb-30" name="sec_registration_file" accept="application/pdf" @change="uploadSecRegFile($event)">
                                 </div>
                               </div>
                               <div class="with-upload row">
                                 <div class="col-lg-7">
                                   <label for="dti_registration_num">DTI Registration Number</label>
                                   <input type="text" class="mb-10" name="dti_registration_num" id="dti_registration_num" v-model="dti_registration_num" v-on:keypress="numericOnly($event)" placeholder="DTI Registration Number">
                                 </div>
                                 <div class="col-lg-5">
                                   <label for="dti_registration_file">Upload File</label>
                                    <input type="file" id="dti_registration_file" class="mb-30" name="dti_registration_file" accept="application/pdf" @change="uploadDtiRegFile">
                                </div>
                               </div>
                               <div class="with-upload row mb-20">
                                 <div class="col-lg-7">
                                   <label for="tin_num">TIN</label>
                                    <input type="text" class="mb-10" name="tin_num" id="tin_num" v-model.lazy="tin_num" placeholder="TIN Number" v-on:keypress="numericOnly($event)">
                                </div>
                                <div class="col-lg-5">
                                  <label for="tin_file">Upload File</label>
                                    <input type="file"  class="mb-30" id="tin_file" name="tin_file" accept="application/pdf" @change="uploadTinFile">
                                </div>
                               </div>

                               <!-- New Added Additional Documents Start -->
                              <div v-for="index in additional_document_count" :key="index" class="with-upload row">
                                <div class="col-lg-7">
                                  <label :for="'additional_document' + index">Additional Document {{ index }}</label>
                                  <input
                                    type="text"
                                    class="mb-10"
                                    :name="'additional_document' + index"
                                    :id="'additional_document' + index"
                                    v-model.lazy="additional_documents[index - 1]"
                                    :placeholder="'Additional Document ' + index + ' Name'"
                                  />
                                </div>
                                <div class="col-lg-5">
                                  <label :for="'additional_document' + index + '_file'">Upload File</label>
                                  <input
                                    type="file"
                                    class="mb-30"
                                    :id="'additional_document' + index + '_file'"
                                    :name="'additional_document' + index + '_file'"
                                    accept="application/pdf"
                                    @change="uploadAdditionalFile(index - 1, $event)"
                                  />
                                </div>
                                <!-- Add Remove Button for additional documents 2 and 3 -->
                                <div class="col-12" v-if="index > 1">
                                  <button class="remove-btn" @click="removeFile(index)">×</button>
                                </div>
                              </div>
                              <div class="add-btn-wrapper">
                              <button :disabled="additional_document_count >= 3" class="file-btn mb-20" @click="addFile">
                                Add Files
                              </button>
                              <p class="note">ⓘ PDF format only, maximum of 3 attachments - 25 MB per file</p>
                            </div>
                               <!-- New Added Additional Documents End-->
                               <!-- New Added Social Media Links Start -->
                               <div>
                                 <label for="links">Links (e.g. Website, Facebook, Youtube, etc.)</label>
                                  <textarea type="text" class="placeholderColor" name="links" v-model="linkInput" id="links" 
                                  placeholder="https://greatfoodsolution.com/,
https://www.facebook.com/greatfoodsolution/,
https://www.youtube.com/channel/UCgIfWa6ZEjoG4KywsoqERuA/"></textarea>
                               </div>

                               <!-- New Added Social Media Links end -->

                                 <h6>Authorized Person</h6>
                               <div class="bordered-content">
                                 <label for="first_name">First Name <span style="color: red;">*</span></label>
                                 <input type="text" name="firstname" id="first_name" v-model="first_name" placeholder="First Name" required>

                                 <label for="last_name">Last Name <span style="color: red;">*</span></label>
                                  <input type="text" name="lastname" id="last_name" v-model="last_name" placeholder="Last Name" required>

                                 <label for="postiion">Position <span style="color: red;">*</span></label>
                                  <input type="text" name="position" id="position" v-model="position" placeholder="Position" required>

                                 <label for="tel_number">Telephone Number <span style="color: red;">*</span></label>
                                  <input type="text" name="tel_number" id="tel_number" v-model="tel_number" maxlength="10" placeholder="Telephone Number (e.g. 02xxxxxxxx)" required>

                                 <label for="mobile_number">Mobile Number <span style="color: red;">*</span></label>
                                  <input type="text" name="mobile_number" id="mobile_number" v-model="mobile_number" maxlength="12" placeholder="Mobile Number (e.g. 09xxxxxxxxx)" required>

                                 <label for="email_address">Email Address <span style="color: red;">*</span></label>
                                  <input type="email" name="email" id="email_address" v-model="email_address" placeholder="Email Address" required>
                               </div>
                               <div>
                                  <!--  <label class="checkbox-inline">
                                      <input type="checkbox" value="" v-model="marketing_consent">
                                      I consent to Herboil processing my personal data in order to send personalized marketing material in accordance with the consent form and the privacy policy.
                                  </label> -->
                                  <label class="checkbox-inline">
                                      <input type="checkbox" value="" v-model="privacy_policy_consent" required>
                                      By clicking "create account", I consent to the privacy policy.
                                  </label>
                                  <div class="btn-wrapper">
                                      <button @click="register" :disabled="submitting" class="theme-btn-1 btn button-1 reverse-color btn-block" type="submit">{{ submitting ? 'PROCESSING' : 'CREATE ACCOUNT' }}</button>
                                  </div>
                               </div>
                             </div>
                           </div>
                          
                        </div>
                        <div class="by-agree text-center">
                            <p>By creating an account, you agree to our:</p>
                            <p><router-link to="/privacy-statement">TERMS OF CONDITIONS  &nbsp; &nbsp;</router-link> | &nbsp; &nbsp;  <a href="#" @click="showPrivacyPolicy">PRIVACY POLICY</a></p>
                            <div class="go-to-btn mt-50">
                                <router-link to="/login">ALREADY HAVE AN ACCOUNT ?</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-if="registered">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area text-center">
                        <h1 ref="title" class="section-title">Registration<br>Successful</h1>
                        <button @click="refreshRegistration" class="theme-btn-1 btn reverse-color button-1 mt-4" type="button">REGISTER AGAIN</button>
                       
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 offset-lg-3">
                    <div class="account-login-inner">
                        <div class="by-agree text-center">
                            <div class="go-to-btn mt-50">
                                <router-link to="/login">ALREADY HAVE AN ACCOUNT ? LOGIN HERE</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- LOGIN AREA END -->
    <AlertDialogue ref="alertDialogue" />
    <ConfirmDialogue ref="confirmDialogue" />
    <Footer />
  </div>
</template>

<style>
.bordered-content {
    padding: 2rem;
    border: 1px solid #d3dcf0;
    border-radius: 3px;
}

.file-btn {
  display: inline-block;
  padding: 6px 12px;
  font-size: 16px;
  font-family: Arial, sans-serif;
  color: #333;
  background-color: #f7f7f7;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 0px;
  min-width: 93px;
}

.file-btn:hover {
  background-color: #e6e6e6;
  border-color: #adadad;
}

.file-btn:active {
  background-color: #d6d6d6;
  border-color: #8c8c8c;
}
.file-btn:disabled {
  background-color: #e6e6e6;
  border-color: #adadad;  
  cursor: not-allowed; /* Cursor style for disabled button */
  opacity: 0.6; /* Reduce opacity to indicate it's disabled */
}
.add-btn-wrapper{
  display: flex;
  align-items: center;
  gap: 10px;
}
.remove-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  font-size: 12px;
  position: absolute;
  cursor: pointer;
  top: -107px;
  right: 10px;
}

.remove-btn::after {
  content: "remove";
  position: absolute;
  bottom: -25px; 
  left: 50%;
  transform: translateX(-50%) translateY(10px); 
  background-color: #333;
  color: #fff;
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 10px;
  white-space: nowrap;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out; 
}
.note {
  color: rgb(203, 41, 41);
  font-size: 14px;
}

.remove-btn:hover::after {
  opacity: 0.9; 
  transform: translateX(-50%) translateY(0); 
}
.remove-btn:hover {
  scale: 105%;
}
@media (max-width: 991px) {
  .remove-btn {
    top: -162px;
    right: 18px;
}
.note {
  font-size: 12px;
}
}
@media (max-width: 419px) {
  .remove-btn {
    top: -200px;
    right: 18px;
}

}


</style>


// WEBPACK FOOTER //
// src/components/page/Register.vue